import React from "react";
import PropTypes from "prop-types";
import styles from "./TestimonialCard.module.scss";

const TestimonialCard = ({ name, role, feedback }) => (
  <div className={styles.card}>
    <div className={styles.nameRole}>
      <span className={styles.name}>{name}</span>
      <span className={styles.role}>{role}</span>
    </div>
    <div className={styles.feedback}>"{feedback}"</div>
  </div>
);

TestimonialCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  feedback: PropTypes.string.isRequired,
};

export default TestimonialCard;
